import React, { useContext } from "react";
import { ResourceContext } from "../../Service/Context/ResourceContext";
import { LoadingAnimation } from "../../Service/ResourceAdapter";
import { isDefined } from "../../Utils/utils";
import { getDocumentTranslator } from "../Document/documentLanguage";
import { useLingui } from "@lingui/react";

const ContactMailPhone = ({ inline, isCustomer, withPartner, language }) => {
  const { contact, customerContact, loading } = useContext(ResourceContext);
  const { i18n } = useLingui();
  const t = getDocumentTranslator(i18n, language);
  const partner = customerContact ? customerContact.partner : undefined;

  if (loading) {
    return <LoadingAnimation />;
  }

  let styles = {
    listStyle: {
      display: inline ? "inline-flex" : "block",
      listStyleType: inline ? "none" : "none",
      marginBottom: 5,
      paddingLeft: 0,
      flexWrap: "wrap",
      justifyContent: "center",
      width: '100%',
    },
    itemStyle: {
      marginRight: inline ? 20 : "unset",
      fontSize: 12,
    },
    propertyRow: {
      whiteSpace: "nowrap",
    },
  };

  const { email, phoneNumber, phoneNumberAlt } = (isCustomer
    ? customerContact
    : contact) ?? {};
  return (
    <ul style={styles.listStyle}>
      {isDefined(email) && (
        <li style={{ ...styles.itemStyle, listStyleType: "none" }}>
          <div>
            {email}
            {withPartner && partner && isDefined(partner.email) && ` ${t("and")} ${partner.email}`}
          </div>
        </li>
      )}
      {isDefined(phoneNumber) && (
        <li style={{ ...styles.itemStyle, ...styles.propertyRow }}>
          <span>{t("phoneLabel")}:</span>
          {" "}
          <a href={"tel:" + phoneNumber}>{phoneNumber}</a>
          {withPartner && partner && isDefined(partner.phoneNumber) && (
            <>
              {" "}
              <span>{t("and")}</span>
              {" "}
              <a href={"tel:" + partner.phoneNumber}>{partner.phoneNumber}</a>
            </>
          )}
        </li>
      )}
      {phoneNumberAlt && (
        <li style={{ ...styles.itemStyle, ...styles.propertyRow }}>
          <span>{t("phoneLabel")}:</span>
          {" "}
          <a href={"tel:" + phoneNumberAlt}>{phoneNumberAlt}</a>
        </li>
      )}
    </ul>
  );
};

export default ContactMailPhone;
